export var ClientEventType;
(function (ClientEventType) {
    ClientEventType[ClientEventType["OFFLINE"] = 0] = "OFFLINE";
    ClientEventType[ClientEventType["ONLINE"] = 1] = "ONLINE";
    ClientEventType[ClientEventType["MESSAGE"] = 2] = "MESSAGE";
    ClientEventType[ClientEventType["MESSAGEWITHCANCELOPTION"] = 3] = "MESSAGEWITHCANCELOPTION";
})(ClientEventType || (ClientEventType = {}));
